export let modalType = {
    ADD: 'add',
    EDIT: 'edit',
    DETAIL: 'detail',
};

export let convertModalType = function (modalType) {
    switch (modalType) {
        case 'add':
            return '등록';
        case 'edit':
            return '수정';
        case 'detail':
            return '상세';
    }
    return '';
};
